import React, { FC, useState } from 'react';
import { partTypeEnum } from '../models/part-type.enum';
import styles from './HybridPartSelector.module.css';

interface HybridPartSelectorProps {
    activePart: partTypeEnum,
    setActivePart: (partType: partTypeEnum) => void,
    getPartName: (partType: partTypeEnum) => string,
}

const HybridPartSelector: FC<HybridPartSelectorProps> = ({ activePart, setActivePart, getPartName }) => {

    return (
        <div className={styles.HybridPartSelector} data-testid="HybridPartSelector">
            <button className={styles.pButton} onClick={() => setActivePart(partTypeEnum.headLeft)}>
                <div className={`${styles.head} ${styles.headLeft}`}>{getPartName(partTypeEnum.headLeft)}</div>
                <div className={`${styles.headbox} ${activePart === partTypeEnum.headLeft ? styles.active : ''}`}></div>
            </button>
            <button className={styles.pButton} onClick={() => setActivePart(partTypeEnum.body)}>
                <div className={`${styles.bodybox} ${activePart === partTypeEnum.body ? styles.active : ''}`}><div className={styles.body}>{getPartName(partTypeEnum.body)}</div></div>
            </button>
            <button className={styles.pButton} onClick={() => setActivePart(partTypeEnum.headRight)}>
                <div className={`${styles.headbox} ${activePart === partTypeEnum.headRight ? styles.active : ''}`}></div>
                <div className={`${styles.head} ${styles.headRight}`}>{getPartName(partTypeEnum.headRight)}</div>
            </button>
        </div>
    )
};

export default HybridPartSelector;
